export default function getErrorText(codeError) {
    return {
		'register.login.message-invalid-credentials': 'Invalid email or password',
		'register.login.message-invalid-params': 'Invalid parameters',
		'register.login.message-invalid-email': 'Invalid email',
		'register.login.message-already-registered': 'Email is already registered. Login instead?',
		'register.email.required': 'Please enter your email!',
		'register.email.wrong-format': 'The email address is in the wrong format!',
		'register.password.required': 'Please enter your password!',
		'register.password.twice': "Passwords don't match",
		'register.strength.msg': "Please enter at least 6 characters and don't use passwords that are easy to guess.",
        undefined: 'Error. Please contact the administrator.'
	}[codeError];
}